import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const VERIFIEDUSEREMAILALERTMODAL_LEGACY_FIELD_ORDER = [
  "heading_color",
  "close_icon_color",
  "close_icon_background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  verifiedUserEmailAlertModalDescriptor: _generatedVerifiedUserEmailAlertModalDescriptor,
  verifiedUserEmailAlertModalModalDefinition,
  verifiedUserEmailAlertModalDashboardLayout,
  verifiedUserEmailAlertModalConfig,
  verifiedUserEmailAlertModalResolveConfig,
  verifiedUserEmailAlertModalProperties,
} = doodModalConfig(
  {
    name: "VerifiedUserEmailAlertModal",
    handle: "verified-user-email-success-modal",
    internal_name: "VerifiedUserEmailAlertModal",
    componentType: 'VerifiedUserEmailAlertModalComponent',
    category: 'modal',
    description: "VerifiedUserEmailAlertModal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "verified-user-email-success-modal",
    sharedFields: {}
  },

  () => ({
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"default","value":"#000"},
      options: {
        "label": "VerifiedUserEmailAlertModal.heading_color"
      }
    }),
    close_icon_color: propertyValue({
      type: 'color',
      value: { type: 'palette', value: 'primary-900' },
      options: {
        label: 'Color of the close icon',
      },
    }),
    close_icon_background_color: propertyValue({
      type: 'color',
      value: { type: 'palette', value: 'primary-200' },
      options: {
        label: 'Background color of the close icon',
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["heading_color", "close_icon_color", "close_icon_background_color"],
          },
        ],
      },
    ],
  })
);

export function verifiedUserEmailAlertModalDescriptor(): IBlockDescriptor;
export function verifiedUserEmailAlertModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function verifiedUserEmailAlertModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedVerifiedUserEmailAlertModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedVerifiedUserEmailAlertModalDescriptor, verifiedUserEmailAlertModalProperties, fieldOrder);
}

export {
  verifiedUserEmailAlertModalModalDefinition,
  verifiedUserEmailAlertModalDashboardLayout,
  verifiedUserEmailAlertModalProperties,
  verifiedUserEmailAlertModalConfig,
  verifiedUserEmailAlertModalResolveConfig,
};

export type VerifiedUserEmailAlertModalConfig = typeof verifiedUserEmailAlertModalConfig;
